import React from 'react';
import Moment from 'react-moment';
import 'moment-timezone';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
  },
  headerContent: {
    padding: '10px 30px 30px 30px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  button: {
    margin: theme.spacing.unit,
  },
  doneIcon: {
    paddingLeft: '5px',
  },
  labelField: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  address: {
    display: 'flex',
    flexDirection: 'column'
  },
  addressSpacer: {
    height: '20px',
  },
});

//TODO:
//1. refactor app to use moment instead of date
//2. replace hack adddress spacer div with correct css
//3. replace hack &nbsp padding on header labels
const InvoiceHeader = (props) => {
  const {
    classes,
    invoice,
    client,
    business
  } = props;

//onClick={() => startEditInvoiceStatuses(invoice.id, {sent: true})}>
  return(
    <div className={classes.header}>
      <div style={{display: 'flex', alignItems: 'center'}}>
        <div style={{ flex: 1,
                      display: 'flex',
                      justifyContent: 'center'
                    }}/>
        <Typography
          variant="title"
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center'
          }}>
          <Moment format="MMMM">{invoice.scheduleDate}</Moment>
          <div style={{paddingLeft: '4px'}}>Invoice</div>
        </Typography>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            paddingRight: '15px',
          }}>
        </div>
      </div>
      <div className={classes.headerContent}>
        <div className={classes.address}>
          <Address classes={classes} data={{title: "From", name: business.companyName, address: business.address}} />
          <div className={classes.addressSpacer}/>
          <Address classes={classes} data={{title: "To", name: client.firstName, address: client.address}} />
        </div>

        <div>
          <div className={classes.labelField}>
            <Typography variant="subheading">Invoice Number:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Typography>
            <Typography variant="subheading">{invoice !== undefined ? invoice.invoiceNumber.toString().padStart(6, "0") : ""}</Typography>
          </div>
          <div className={classes.labelField}>
            <Typography variant="subheading">Invoice Date:</Typography>
            <Moment format="DD/MM/YYYY">
                {invoice.invoiceDate}
            </Moment>
          </div>
          <div className={classes.labelField}>
            <Typography variant="subheading">Due Date:</Typography>
            <Moment format="DD/MM/YYYY">
                {invoice.dueDate}
            </Moment>
          </div>
          <div className={classes.labelField} style={{paddingTop: '15px'}}>
            <Typography variant="subheading">Total:&nbsp;&nbsp;</Typography>
            <Typography variant="subheading">${invoice.grandTotal.toFixed(2)}</Typography>
          </div>
          <div className={classes.labelField}>
            <Typography variant="subheading">Balance:&nbsp;&nbsp;</Typography>
            <Typography variant="subheading">${invoice.balance.toFixed(2)}</Typography>
          </div>
        </div>
      </div>
    </div>
  );
}

const Address = ({classes, data, client}) =>
  <div>
    <Typography variant="title">
      {data.title}
    </Typography>
    <Typography variant="subheading">
      {data.name.toUpperCase()}
    </Typography>
    <Typography variant="body1">
      {data.address}
    </Typography>
  </div>

export default withStyles(styles)(InvoiceHeader);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice/Preview/InvoiceHeader.jsx